import dayjs from "dayjs";
import Flex from "../../../../../../../components/Flex";
import { formatDate } from "../../../../../../../utils/date-time-utility";
import { CHART_COLORS } from "../../../../../../../components/app/provider/patient/chart";

const DateStrip = ({ date }: { date: string }) => {
  const isToday = dayjs(date).isSame(dayjs(), "day");
  const isYesterday = dayjs(date).isSame(dayjs().subtract(1, "day"), "day");

  const formattedDate = formatDate(date);

  const DateContent = isToday
    ? `Today, ${formattedDate}`
    : isYesterday
      ? `Yesterday, ${formattedDate}`
      : formattedDate;

  return (
    <Flex
      alignItems="center"
      gap={1.5}
      sx={{
        width: "100%",
        px: 1.5,
        py: 0.5,
      }}
    >
      <div style={{ flex: 1, height: 1, background: CHART_COLORS.border }} />
      <span
        style={{
          color: CHART_COLORS.textDark,
          fontWeight: 400,
          fontSize: 12,
          whiteSpace: "nowrap",
        }}
      >
        {DateContent}
      </span>
      <div style={{ flex: 1, height: 1, background: CHART_COLORS.border }} />
    </Flex>
  );
};

export default DateStrip;
